
import { useState, useEffect } from "react";
import { Search, Filter } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getBlogCategories } from "@/data/blogPosts";

interface BlogSearchProps {
  onSearch: (query: string) => void;
  onCategoryChange: (category: string | null) => void;
}

export const BlogSearch = ({ onSearch, onCategoryChange }: BlogSearchProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [categories, setCategories] = useState<string[]>([]);
  
  useEffect(() => {
    setCategories(getBlogCategories());
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };
  
  return (
    <div className="mb-8 bg-white p-5 rounded-lg shadow-soft">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Input
              type="text"
              placeholder="Search blogs..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10"
            />
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-dental-muted" size={18} />
          </div>
          
          <div className="md:w-64">
            <Select onValueChange={(value) => onCategoryChange(value === "all" ? null : value)}>
              <SelectTrigger className="w-full">
                <div className="flex items-center">
                  <Filter size={16} className="mr-2 text-dental-muted" />
                  <SelectValue placeholder="All Categories" />
                </div>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Categories</SelectItem>
                {categories.map((category) => (
                  <SelectItem key={category} value={category}>
                    {category}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <Button type="submit" className="bg-dental-highlight hover:bg-dental-highlight/90">
            Search
          </Button>
        </div>
      </form>
    </div>
  );
};
